interface PaginationProps {
  current: number;
  totalPages: number;
  onChange: (page: number) => void;
}

function buildPages(current: number, total: number): (number | "...")[] {
  if (total <= 7) return Array.from({ length: total }, (_, i) => i + 1);
  const pages: (number | "...")[] = [1];
  const start = Math.max(2, current - 1);
  const end = Math.min(total - 1, current + 1);
  if (start > 2) pages.push("...");
  for (let i = start; i <= end; i += 1) pages.push(i);
  if (end < total - 1) pages.push("...");
  pages.push(total);
  return pages;
}

export default function Pagination({ current, totalPages, onChange }: PaginationProps) {
  if (totalPages <= 1) return null;
  const pages = buildPages(current, totalPages);

  const baseBtn =
    "flex h-9 min-w-[36px] items-center justify-center rounded-md px-2 text-sm transition-colors";

  return (
    <nav className="mt-8 flex items-center justify-center gap-1.5" aria-label="分页导航">
      <button
        type="button"
        disabled={current <= 1}
        onClick={() => onChange(current - 1)}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700`}
        aria-label="上一页"
      >
        <i className="ri-arrow-left-s-line text-lg" />
      </button>

      {pages.map((p, idx) =>
        p === "..." ? (
          <span key={`gap-${idx}`} className="px-1 text-sm text-foreground-400">
            …
          </span>
        ) : (
          <button
            key={p}
            type="button"
            onClick={() => onChange(p)}
            aria-current={p === current ? "page" : undefined}
            className={`${baseBtn} ${
              p === current
                ? "bg-primary-500 font-medium text-background-50"
                : "border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600"
            }`}
          >
            {p}
          </button>
        ),
      )}

      <button
        type="button"
        disabled={current >= totalPages}
        onClick={() => onChange(current + 1)}
        className={`${baseBtn} border border-background-300 text-foreground-700 hover:border-primary-400 hover:text-primary-600 disabled:cursor-not-allowed disabled:opacity-40 disabled:hover:border-background-300 disabled:hover:text-foreground-700`}
        aria-label="下一页"
      >
        <i className="ri-arrow-right-s-line text-lg" />
      </button>
    </nav>
  );
}